import { render, staticRenderFns } from "./CreateStudent.vue?vue&type=template&id=e8909f96&scoped=true"
import script from "./CreateStudent.vue?vue&type=script&lang=js"
export * from "./CreateStudent.vue?vue&type=script&lang=js"
import style0 from "./CreateStudent.vue?vue&type=style&index=0&id=e8909f96&lang=css"
import style1 from "./CreateStudent.vue?vue&type=style&index=1&id=e8909f96&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8909f96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8909f96')) {
      api.createRecord('e8909f96', component.options)
    } else {
      api.reload('e8909f96', component.options)
    }
    module.hot.accept("./CreateStudent.vue?vue&type=template&id=e8909f96&scoped=true", function () {
      api.rerender('e8909f96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentDialog/CreateStudent.vue"
export default component.exports